import axiosClient from "../../../../../system/helpers/axiosConfig";
import { generatePath } from "react-router-dom";

export const postFindGamers = (id) => {
  const url = generatePath("api/stats/gamer/search/:id", { id });
  return axiosClient.get(url, { params: { id } }).then((r) => r.data);
};
